module.exports = __webpack_public_path__ + "media/images/tutorial_header_sp3-05-0784e0e4c02a198a8b769a6130e5586a.png";